//natives
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

//components
import Pedidos from '../../../../../../util/consultaPedidos/.mixins';

export default class Pendentes extends Component {
    render() {
        return(
            <>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} - Pendentes`}</title>
                </Helmet>
                <Pedidos {...this.props}/>
            </>
        );
    }
}